// extracted by mini-css-extract-plugin
export default {"page":"ClosingSales_page__rOwpv","container":"ClosingSales_container__e41IO","tickets":"ClosingSales_tickets__EIXx3","ticket":"ClosingSales_ticket__X+qUV"};